import { IStore } from "..";
import { THierarchyGroupReducerState } from "../../app/types/connect-types";

export const getState = (state: IStore): THierarchyGroupReducerState => state.hierarchyGroupsReducer;